import React from 'react';
import Heading from '../../../../generic-components/Heading';
import { HELP_SCREEN_DATA_NEW } from '../../constants';
import { ReactComponent as Arrow } from '../../../../assets/icons/svg/shared/ic-shared-right-arrow.svg';

interface IProps {
  title: string;
  icon: React.ReactNode;
  onClick: () => void;
  testId: string;
  isSelected?: boolean;
  shouldHideArrow?: boolean;
}
export const LoginHelpOption = ({ title, icon, onClick, testId, isSelected, shouldHideArrow }: IProps) => (
  <div
    className={`${HELP_SCREEN_DATA_NEW.OPTIONS.STYLE.CONTAINER.CLASS_NAME} ${isSelected ? 'border-action03' : 'border-bw04'}`}
    onClick={onClick}
    tabIndex={0}
    role='button'
    onKeyDown={() => {}}
    data-testid={testId}
  >
    <div className='flex gap-2 justify-center'>
      {icon}
      <Heading title={title} className={HELP_SCREEN_DATA_NEW.OPTIONS.STYLE.HEADING.CLASS_NAME} />
    </div>
    {!shouldHideArrow && <Arrow className='self-right w-[16px] h-[16px] text-bw07' />}
  </div>
);
